const state = {
    genderPricePerChannel: [],
    isGenderPriceLoading: false,
    cancelTokenSource: null,
    currentRequestTimestamp: null,
}

const getters = {
    getGenderPricePerChannel: state => state.genderPricePerChannel,
    getLoadingGenderPrice: state => state.isGenderPriceLoading
}

const actions = {
    getEventFromId: ({ commit, rootState }, eventId) => {
        return axios.get('/api/Event/GetById', {
            params:{
                supplierId: rootState.user.account.supplierId,
                eventId: eventId,
            }
        }).then(response => {
            return response
        })
    },

    async downloadGenderPricePerChannel({ state, rootState, commit }, payload) {
        // Cancel previous request
        if (state.cancelTokenSource) {
            state.cancelTokenSource.cancel('Operation canceled due to new request.');
        }

        // New cancelToken and timeStamp for new request
        const cancelTokenSource = axios.CancelToken.source();
        const requestTimestamp = Date.now();

        state.cancelTokenSource = cancelTokenSource;
        state.currentRequestTimestamp = requestTimestamp;
        state.isGenderPriceLoading = true;

        try {
            let response = await axios.get('/api/Event/GetGenderPricePerChannelByEventId', {
                params: {
                    supplierId: rootState.user.account.supplierId,
                    eventId: payload
                },
                cancelToken: cancelTokenSource.token
            });

            // Check if is the most recent answer
            if (state.currentRequestTimestamp === requestTimestamp) {
                if (response && response.status === 200 && response.data) {
                    commit('SET_GENDER_PRICE_PER_CHANNEL', response.data);
                }
            }
        } catch (err) {
            if (!axios.isCancel(err) && state.currentRequestTimestamp === requestTimestamp) {
                commit('RESET_GENDER_PRICE_PER_CHANNEL');
            }
        } finally {
            // Clear cancelToken and timeStamp
            if (state.currentRequestTimestamp === requestTimestamp) {
                state.isGenderPriceLoading = false;
                state.cancelTokenSource = null;
                state.currentRequestTimestamp = null;
            }
        }
    },
}

const mutations = {
    SET_GENDER_PRICE_PER_CHANNEL: (state, data) => {
        state.genderPricePerChannel = data;
        state.isGenderPriceLoading = false;
    },
    RESET_GENDER_PRICE_PER_CHANNEL: (state, data) => {
        state.genderPricePerChannel = [];
        state.isGenderPriceLoading = false;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js